<template>
  <div>
    <NodePage v-if="node && pageType === 'NodePage'" v-bind="node" />
    <NodeApprenticeships v-if="node && pageType === 'NodeApprenticeships'" v-bind="node" />
    <NodeCareerWorlds v-if="node && pageType === 'NodeCareerWorlds'" v-bind="node" />
    <NodeNews v-if="node && pageType === 'NodeNews'" v-bind="node" />
    <NodeLocations v-if="node && pageType === 'NodeLocations'" v-bind="node" />
  </div>
</template>

<script lang="ts" setup>
import type {
  EntityUrlFragment,
  NodePageFragment,
  NodeApprenticeshipsFragment,
  NodeCareerWorldsFragment,
  NodeNewsFragment,
  NodeLocationsFragment,
} from '#graphql-operations'


defineOptions({
  name: 'PageSlug',
})

definePageMeta({
  name: 'drupal-route',
  path: '/equans/:slug(.*)*',
})

const nuxtRoute = useRoute()

// Get the data.
const { data: query } = await useAsyncData('equans-' + nuxtRoute.path, async () => {
  return await useGraphqlQuery('domainRoute', {
    path: nuxtRoute.path,
    domainId: 'equans',
  }).then((v) => {
    return v.data
  })
})

// Handles redirects and metatags.
const { entity: node } = await useDrupalRoute<NodePageFragment | NodeApprenticeshipsFragment | NodeCareerWorldsFragment | NodeNewsFragment | NodeLocationsFragment>(query.value)

const pageType = computed(() => {
  const route = query?.value?.route as EntityUrlFragment
  return route.entityGlobal?.__typename
})

setBreadcrumbLinksFromRoute(query.value)
setLanguageLinksFromRoute(query.value)
await renderPageDependencies()
</script>
